<div class="select-input col-12 col-md">
  <label class="select-input__label">{{ label }}</label>

  <ng-container *ngIf="!searchable; else searchableSelect">
    <select class="form-select select-input__control" [formControl]="control" [class.is-invalid]="showError"
      (blur)="onBlur()">
      <option value="" disabled>{{ placeholder }}</option>
      <option *ngFor="let opt of options" [value]="opt.value">
        {{ opt.label }}
      </option>
    </select>
  </ng-container>

  <ng-template #searchableSelect>
    <div class="select-input__searchable" [class.is-open]="dropdownOpen">
      <button
        type="button"
        class="form-select select-input__control select-input__trigger"
        [class.is-invalid]="showError"
        [attr.aria-expanded]="dropdownOpen"
        (click)="toggleDropdown()">
        <span [class.select-input__placeholder]="!selectedLabel">
          {{ selectedLabel || placeholder }}
        </span>
      </button>

      <div *ngIf="dropdownOpen" class="select-input__menu">
        <input
          type="text"
          class="form-control select-input__search"
          [placeholder]="searchPlaceholder"
          [value]="searchTerm"
          (input)="onSearchInput($event)" />

        <div class="select-input__options">
          <button
            type="button"
            class="select-input__option"
            *ngFor="let opt of filteredOptions"
            (click)="selectOption(opt)">
            {{ opt.label }}
          </button>

          <div *ngIf="filteredOptions.length === 0" class="select-input__empty">
            {{ 'CAMPAIGN.Inputs.NoResults' | translate }}
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div *ngIf="showError" class="text-danger small mt-1">
    {{ 'CAMPAIGN.Inputs.Errors.Required' | translate }}
  </div>
</div>
